export const ActionType = {
  Spara: 1,
  Skapa: 2,
  Skicka: 4,
  Godkanna: 8,
  Starta: 16,
  Signera: 32,
  Kontrollera: 64,
  Slutrapportera: 128,
  Avsla: 256,
  Vidarebefodra: 512,
  AvslaSignering: 1024,
  AvslaKontrollering: 2048,
  AvslaGodkanna: 4096,
};
export const PermissionTypes = {
  Godkanna: 1,
  Starta: 2,
  RegistreraSignera: 4,
  Kontrollera: 8,
  Slutrapportera: 16,
  Skapa: 32,
};
export const ArrangemangDisplayType = {
  ArrangemangWizard: 1,
  ArrangemangOverview: 2,
  ArrangemangWizardFromOverview: 3,
  ArrangemangOverviewOnlySee: 4,
};
export const RequiredType = {
  arrAnsvarig: 1,
  frikodcentral: 2,
  sal: 4,
  material: 8,
  huvudsamverkanspart: 16,
  sluttid: 32,
  startdatum: 64,
  starttid: 128,
  studieplan: 256,
  underkonto1: 512,
  underkonto2: 1024,
  underkonto3: 2048,
  underkonto4: 4096,
  underkonto5: 8182,
  underkonto6: 16364,
  amne: 32768,
  huvudledare: 65536,
  rapporteringsansvarig: 131072,
  namn: 262144,
  kommun: 524288,
  notering: 1048576,
  //arrangemangstyp: 2097152,
  kulturform: 4194304,
  medverkandeTyp: 8388608,
  medArrangor: 16777216,
  kontor: 33554432,
  planeratAntalSammankomster: 67108864,
  planeratAntalTimmar: 134217728,
  deltagare: 268435456,
  arbetsplan: 536870912,
  frikodlokal: 1073741824,
};
export const Printtype = {
  Deltagarlista: 1,
  Anstallningsavtal: 2,
  Arbetsplan: 3,
  NarvaroLista: 4,
  Uppfoljning: 5,
};
export const ViewType = {
  VisaGodkända: -9, //Arrstatus : 1,2,3
  VisaPågående: -8, //Arrstatus 4
  VisaSlutförda: -7, //Arrstatus : 5,6,7,8 innevarande år
  VisaArkiverade: -6, //Arrstatus 8
  Godkända: -5,
  AttSkickaTillStartare: -4,
  InskickadeSomSkaGodkännas: -3,
  NekadeSomSkaKompletteras: -2,
  EjInskickade: -1,
  Ingen: 0,
  AttGodkänna: 1,
  AttStarta: 2,
  AttRegistreraNärvaro: 4,
  AttKontrollera: 8,
  AttSlutrapportera: 16,
  AttSkapa: 32,
  RedigeraStartade: 64,
};
export const ListType = {
  User: 0,
  Samverkanspart: 1,
  Avdelning: 2,
};
export const StepType = {
  Obligatoriska: 0,
  About: 1,
  Sammankomst: 2,
  Salbokning: 3,
  Kultur: 4,
  MaterialStudAmne: 5,
  Medverkandes: 6,
  Deltagares: 7,
  Internt: 8,
  Ekonomi: 9,
  Webb: 10,
};

export const SchemaFrekvens = {
  VARJE_VECKA: 0,
  VARANNAN_VECKA: 1,
  VAR_TREDJE_VECKA: 2,
  VAR_FJARDE_VECKA: 3,
  OREGELBUNDET_LEDAREN_SKAPAR: 4,
};

export const AccountType = {
  Arrangemang: 0,
  Samverkanspart: 1,
  Bokningshanterare: 2,
};
export const ArrStatus = {
  Skapat: 0,
  Möjligt: 1,
  Planerat: 2,
  Startklart: 3,
  Startat: 4,
  Signerat: 5,
  Kontrollerat: 6,
  Slutrapporterat: 7,
  SkickatTillFbr: 8,
  Sprucket: 10,
};

export const LoggHandelse = {
  "Visa Alla": 0,
  Namnbyte: 1,
  "Ny Medlem": 2,
  "Medlem borttagen": 3,
  "Medlemsuppgifter ändrade": 4,
  "Uppgifter ändrade": 5,
};

export const DeviceType = {
  Computer: 1,
  Mobile: 2,
  Both: 3,
};

export const MoviePlacement = {
  Alla: 511,
  "Registrera närvaro": 1,
  "Rapportera kulturprogram": 2,
  "Signera arrangemang": 4,
  "Skapa studiecirkel": 8,
  "Skapa kultur": 16,
  "Skapa annan folkbildningsverksamhet": 32,
  "Skapa Svenska från dag 1, studiecirkel": 64,
  "Skapa Svenska från dag 1, annan folkb.v.": 128,
  Startsidan: 256,
};

export const MovieOrder = [511, 256, 1, 2, 4, 8, 16, 32, 64, 128];

export const BankIDCertErrorCode = {
  Unknown: 0,
  AlreadyInProgress: 1,
  InvalidParameters: 2,
  Canceled: 3,
  Unauthorized: 4,
  NotFound: 5,
  RequestTimeout: 6,
  UnsupportedMediaType: 7,
  InternalError: 8,
  Maintenance: 9,
};

export const UtformatFaktura = {
  Papper: 0,
  Fil: 1,
  Mail: 2,
  Inget: 3,
};

export const UtbetalningKontotyp = {
  Inget: 0,
  Bankkonto: 1,
  Bankgiro: 2,
  Plusgiro: 3,
};

export const BokningsStatus = {
  Bokad: 0,
  Preliminar: 1,
  Utkast: 2,
  Avbojd: 3,
  Ingen: 5,
};

export const Actions = {
  AddDeltagare: "AddDeltagare",
  AddSchemas: "AddSchemas",
  AnstallningsBevis: "AnstallningsBevis",
  ApproveSchema: "ApproveSchema",
  ApproveTerms: "ApproveTerms",
  CancelSchema: "CancelSchema",
  ContactArransvarig: "ContactArransvarig",
  ContactDeltagares: "ContactDeltagares",
  CreateSchema: "CreateSchema",
  EditArbetsplan: "EditArbetsplan",
  EditNarvaro: "EditNarvaro",
  EditSchema: "EditSchema",
  EditSchemas: "EditSchemas",
  HandleDeltagare: "HandleDeltagare",
  HandleDocuments: "HandleDocuments",
  LearnifyURL: "LearnifyURL",
  PrintAnstallningsavtal: "PrintAnstallningsavtal",
  PrintDeltagarLista: "PrintDeltagarLista",
  RemoveSchema: "RemoveSchema",
  ResultModal: "ResultModal",
  ShowArtists: "ShowArtists",
  ShowDeltagare: "ShowDeltagare",
  ShowDouble: "ShowDouble",
  ShowOverview: "ShowOverview",
  ShowResult: "ShowResult",
  ShowSchema: "ShowSchema",
  ShowWebbsvars: "ShowWebbsvars",
};
